import { Vessel } from 'anchor-shared/lib/model/entity/vessel';
import { VesselAvailability } from 'anchor-shared/lib/model/entity/vesselAvailability';

export function buildRouteEnding(vessel: Vessel): string {
  return (
    vessel.lengthFt + '-' + replaceSpaceWithDash(vessel.make) + '-' + vessel.id
  );
}

export function buildRouteEndingForVesselAvailability(
  vesselAvailability: VesselAvailability,
): string {
  return (
    vesselAvailability.length +
    '-' +
    replaceSpaceWithDash(vesselAvailability.make) +
    '-' +
    vesselAvailability.vesselId
  );
}

export function replaceSpaceWithDash(make: string): string {
  return make.replace(/\s+/g, '-').toLowerCase();
}
